// meetingRooms/components/prices/view.js - SIMPLE fix for update only
import React from 'react';
import {
  CircularProgress,
  Alert,
  Typography
} from '@mui/material';
import {
  MeetingRoom as MeetingRoomIcon
} from '@mui/icons-material';
import TariffCard from './TariffCard';

// Import the honey-themed styled components
import {
  HoneyPricingContainer,
  HoneyPricingHeader,
  HoneyPricingTitle,
  HoneyPricingSubtitle,
  StyledEmptyState,
  StyledLoadingContainer
} from './styled';

const PricingView = ({
  resource,
  tariffs,
  isVatInclusive,
  isLoadingTariffs,
  tariffError,
  vatRate,
  showSnackbar,
  setIsVatInclusive,
  setTariffError,
  handleTariffUpdated
}) => {
  const renderHeader = () => (
    <HoneyPricingHeader>
      <HoneyPricingTitle>
        <MeetingRoomIcon />
        Pricing & Tariffs
      </HoneyPricingTitle>
      <HoneyPricingSubtitle>
        Update the pricing options for this meeting room.
      </HoneyPricingSubtitle>
    </HoneyPricingHeader>
  );

  return (
    <HoneyPricingContainer>
      {renderHeader()}

      {/* Error Alert */}
      {tariffError && (
        <Alert
          severity={tariffError?.includes('successfully') ? "success" : "error"}
          sx={{ mb: 2, borderRadius: '12px' }}
          onClose={() => setTariffError('')}
        >
          {tariffError}
        </Alert>
      )}

      {/* Tariffs Content */}
      {isLoadingTariffs ? (
        <StyledLoadingContainer>
          <CircularProgress size={32} />
          <Typography variant="body2" sx={{ mt: 1 }}>
            Loading tariff data...
          </Typography>
        </StyledLoadingContainer>
      ) : tariffs.length === 0 ? (
        <StyledEmptyState severity="info" sx={{ mb: 2 }}>
          No tariffs found for this meeting room.
        </StyledEmptyState>
      ) : (
        <>
          {/* Existing Tariffs - UPDATE ONLY */}
          {tariffs.map((tariff) => (
            <TariffCard
              key={tariff.slug}
              tariff={tariff}
              isVatInclusive={isVatInclusive}
              vatRate={vatRate}
              onTariffUpdated={handleTariffUpdated}
              resource={resource}
              showSnackbar={showSnackbar}
            />
          ))}
        </>
      )}
    </HoneyPricingContainer>
  );
};

export default PricingView;